import type { Account } from './account.type.ts';
export interface AccountExtension extends Account {}
export class AccountExtension {
  // ── Computed Properties ──
  get institutionName() {
    return this.financialInstitution?.name;
  }

  get currency() {
    return 'USD';
  }

  get activeLoans() {
    return this.loans?.filter((e) => e.isActive) || [];
  }

  get nsldsPslfLoans() {
    return this.activeLoans.filter((loan) => loan.hasNsldsPslfData);
  }

  get hasNsldsPslfData() {
    return (
      this.observation?.provider === 'ObservableProvider.NSLDS' || this.nsldsPslfLoans.length > 0
    );
  }

  get loanTotal() {
    return this.observation?.balance || 0;
  }

  get loanInterestAverage() {
    return this.observation?.['interest-weighted-average'] || 0;
  }

  get interestBalance() {
    return this.observation?.['interest-balance'] || 0;
  }

  get principalBalance() {
    return this.observation?.['principal-balance'] || 0;
  }

  get loanMinMonthlyPayment() {
    const minPayment = this.observation?.['minimum-monthly-payment'];
    if (minPayment != null) return minPayment / 100;
    return this.observation?.['provider-amount-due'] || 0;
  }

  get providerRegularMonthlyPayment() {
    return this.observation?.['provider-regular-monthly-payment'] || 0;
  }

  get providerAttemptAt() {
    return this.observation?.['provider-attempt-at'] || '';
  }

  get providerSuccessAt() {
    return this.observation?.['provider-success-at'] || '';
  }

  get inRelink() {
    return this.observation?.['action'] === 'RELINK';
  }

  get repaymentPlans() {
    const filtered = [
      ...new Set(this.activeLoans.map((loan) => loan.repaymentPlan).filter((el) => el)),
    ];
    return filtered.join(', ');
  }

  get repaymentStatuses() {
    const filtered = this.activeLoans.map((loan) => loan.status).filter((el) => el);

    return filtered.join(', ');
  }

  get isPaidOff() {
    return this.observation?.['is-paid-off'] || false;
  }

  get accountNumber() {
    return this.observation?.['payable-account-number'] || '';
  }
}

const Registration = {
  kind: 'object',
  name: 'account',
  features: AccountExtension,
};
export default Registration;
